import { useState, useEffect } from 'react'

const buyers = [
  { name: 'Martín', city: 'Córdoba' },
  { name: 'Lucía', city: 'Buenos Aires' },
  { name: 'Pablo', city: 'Rosario' },
  { name: 'Sofía', city: 'Mendoza' },
  { name: 'Alejandro', city: 'La Plata' },
  { name: 'Valentina', city: 'Mar del Plata' },
  { name: 'Nicolás', city: 'Tucumán' },
  { name: 'Camila', city: 'Neuquén' },
]

export function useSocialProof() {
  const [visible, setVisible] = useState(false)
  const [buyer, setBuyer] = useState(buyers[0])

  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setVisible(true)
    }, 4000)

    // Loop
    const interval = setInterval(() => {
      setVisible(false)

      setTimeout(() => {
        const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)]
        setBuyer(randomBuyer)
        setVisible(true)
      }, 2000) // Wait 2s before showing next

      // Hide after 4s
      setTimeout(() => {
        setVisible(false)
      }, 6000) // 2s wait + 4s show = 6s cycle start
    }, 10000) // Total cycle 10s

    return () => {
      clearTimeout(initialTimeout)
      clearInterval(interval)
    }
  }, [])

  return { visible, buyer, setVisible }
}
